export default __webpack_public_path__ + "static/media/bg-pattern-top-desktop.9d4ba9c9.svg";